import React from 'react';
import { Trans } from '@lingui/react';

export default {
  title: <Trans id="general.summaryTerms.byClickingOnNext" />,
  continue: <Trans id="general.continue" />,
  termsOfService: <Trans id="general.termsOfService" />,
};
